/* klaasje-announcement
   ─────────────────────────────────────────────────────────────
   Houdt bij hoeveel van de aankondigingsbalk nog in beeld staat en
   schrijft dat als --klaasje-announcement-y op <html>. De pill (en de
   drawers en het filterpaneel die op zijn plek uitlijnen) staan dat stuk
   lager, dus de pill zweeft onder de balk en schuift mee omhoog als je
   scrolt, tot zijn gewone plek.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var balk = document.querySelector('[data-klaasje-announcement]');
  if (!balk) return;

  var html = document.documentElement;
  var laatste = null;
  var gepland = false;

  function zet() {
    gepland = false;
    var y = Math.max(0, Math.round(balk.getBoundingClientRect().bottom));
    if (y === laatste) return;
    laatste = y;
    html.style.setProperty('--klaasje-announcement-y', y + 'px');
  }

  function plan() {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(zet);
  }

  zet();
  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan, { passive: true });
  /* na een terug-navigatie of refresh zet de browser de scrollpositie
     soms pas later terug */
  window.addEventListener('pageshow', plan);
  window.addEventListener('load', plan);
})();
